import { render, staticRenderFns } from "./ComprasManutencaoPreco.vue?vue&type=template&id=18647813&scoped=true"
import script from "./ComprasManutencaoPreco.vue?vue&type=script&lang=js"
export * from "./ComprasManutencaoPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18647813",
  null
  
)

export default component.exports